export default "__VITE_ASSET__D$Dqrk_U__"